import BaseDataObject from './BaseDataObject';

export default class Track extends BaseDataObject {
  getCode() {
    return this.getString('code');
  }

  getName() {
    return this.getString('domesticText');
  }
}
